import React from "react";
import { Star, ArrowUpRight, ShieldCheck } from "lucide-react";
import { bestSellers, aff } from "../mock";

function ProductCard({ p }) {
  return (
    <div className="product-card group flex flex-col">
      <a
        href={p.href}
        target="_blank"
        rel="noreferrer"
        className="relative block bg-[#F5EFE6] overflow-hidden aspect-[4/5]"
      >
        <img
          src={p.img}
          alt={p.name}
          className="product-img-main absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
        {p.hoverImg && (
          <img
            src={p.hoverImg}
            alt=""
            className="product-img-hover absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
        )}
        {p.off && (
          <span className="absolute top-3 left-3 bg-[#1a1a1a] text-[#FBF8F4] text-[10px] tracking-[0.18em] font-semibold uppercase px-2.5 py-1">
            {p.off}
          </span>
        )}
        {p.tag && (
          <span className="absolute top-3 right-3 bg-[#C9A961] text-[#1a1a1a] text-[10px] tracking-[0.18em] font-semibold uppercase px-2.5 py-1">
            {p.tag}
          </span>
        )}
      </a>

      <div className="pt-5 flex flex-col gap-2">
        {p.brand && (
          <p className="font-sans-y text-[10px] tracking-[0.25em] uppercase text-[#7a7a7a]">
            {p.brand}
          </p>
        )}
        <a
          href={p.href}
          target="_blank"
          rel="noreferrer"
          className="font-serif-y text-[17px] leading-snug text-[#1a1a1a] hover:text-[#C9A961] transition-colors line-clamp-2 min-h-[46px]"
        >
          {p.name}
        </a>
        <div className="flex items-center gap-1.5">
          {[...Array(5)].map((_, i) => (
            <Star
              key={i}
              size={12}
              fill={i < Math.round(p.rating) ? "#C9A961" : "transparent"}
              color="#C9A961"
            />
          ))}
          <span className="font-sans-y text-[11px] text-[#7a7a7a] ml-1">{p.rating.toFixed(1)}</span>
        </div>
        <div className="flex items-baseline gap-2">
          <span className="font-sans-y text-[16px] font-semibold text-[#1a1a1a]">
            ${p.price.toFixed(2)}
          </span>
          {p.compareAt && (
            <span className="font-sans-y text-[13px] text-[#a3a3a3] line-through">
              ${p.compareAt.toFixed(2)}
            </span>
          )}
        </div>
        <a
          href={p.href}
          target="_blank"
          rel="noreferrer"
          className="mt-3 btn-y-outline justify-center w-full"
        >
          Buy Now <ArrowUpRight size={14} />
        </a>
        <p className="flex items-center justify-center gap-1.5 mt-2 font-sans-y text-[10px] text-[#7a7a7a]" data-testid="trust-badge">
          <ShieldCheck size={13} className="text-[#C9A961]" />
          Secure checkout on the official Ybera store
        </p>
      </div>
    </div>
  );
}

export default function BestSellers() {
  return (
    <section className="section bg-[#FBF8F4]">
      <div className="container-y">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <p className="font-sans-y text-[11px] tracking-[0.3em] uppercase text-[#C9A961] mb-3">
              Curated for you
            </p>
            <h2 className="font-serif-y text-4xl md:text-5xl text-[#1a1a1a]">Best Sellers</h2>
          </div>
          <a
            href={aff("/collections/best-sellers")}
            target="_blank"
            rel="noreferrer"
            className="hidden md:inline-flex font-sans-y text-[12px] tracking-[0.2em] uppercase text-[#1a1a1a] border-b border-[#1a1a1a] pb-1 hover:text-[#C9A961] hover:border-[#C9A961] transition-colors"
          >
            See all
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8">
          {bestSellers.map((p) => (
            <ProductCard key={p.id} p={p} />
          ))}
        </div>
      </div>
    </section>
  );
}
